export default __webpack_public_path__ + "static/media/LogoLucatmi.0aa7cf6b.svg";